module.exports = __webpack_public_path__ + "img/crystalPoppers.297e1a48.png";